import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { studentFeedbackListingModel } from 'common/models/page-models/student-feedback/student-feedback-grid-model';
import { studentFeedbackModel } from 'common/models/page-models/student-feedback/student-feedback-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { studentFeedbackGridWidgetService } from 'common/widget/student-feedback/Student-feedback-widget.service';


 
@Injectable({
    providedIn: 'root'
})
export class studentFeedbackGridResolver extends GridResolver<studentFeedbackModel, studentFeedbackListingModel> {
    constructor(
        protected fs: studentFeedbackGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
       
    }

    
}